"use client";
import React, { useState } from "react";
import {
  Button,
  TextField,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import Image from "next/image";
import AppleStore from "../../assets/AppleStore.png";
import AndriodStore from "../../assets/AndroidStore.png";
// import AppImage from "../../assets/app-background.jpg";
// import Iphone from "../../assets/iphone.jpg";
import "./index.css";

const GetApp = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [code, setCode] = React.useState(1);

  const handleChange = (event: SelectChangeEvent<number>) => {
    setCode(event.target.value as number);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log("Submitted phone number:", phoneNumber);
  };

  return (
    <div style={{ marginTop: "3rem" }} id="get-app-scroll">
      <div className="hero">
        <div className="get-app-container">
          <div className="hero__inner">
            <div className="hero__info">
              <Typography
                sx={{ fontSize: { xs: "28px", sm: "48px" }, fontWeight: 600 }}
              >
                Get the SalonTym App
              </Typography>
              <br />
              <h2>
                We will send you a link. Open it on your phone to download app.
              </h2>
              <br />

              <Box
                component="form"
                onSubmit={handleSubmit}
                className="input-number-container"
                alignItems="center"
                sx={{
                  borderRadius: "4px",
                  padding: "8px",
                  width: "fit-content",
                  margin: "auto",
                }}
              >
                <Box className="input-number-first-container">
                  {/* <span
                    style={{
                      marginRight: "1rem",
                      border: "1px solid #ccc",
                      background: "#fff",
                      padding: "10px 12px",
                      borderRadius: "4px",
                    }}
                  >
                    +91
                  </span> */}
                  <Box
                    sx={{
                      marginRight: "1rem",
                      background: "#fff",
                      borderRadius: "4px",
                    }}
                  >
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={code}
                        onChange={handleChange}
                        sx={{
                          "& .MuiSelect-select.MuiInputBase-input.MuiOutlinedInput-input":
                            {
                              padding: "12px 32px 12px 14px",
                            },
                        }}
                      >
                        <MenuItem value={1}>+91</MenuItem>
                        <MenuItem value={2}>+977</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Phone number"
                    inputProps={{ maxLength: 10 }} // Adjust max length as needed
                    InputProps={{
                      sx: {
                        padding: "3px", // Adjust padding as needed
                      },
                    }}
                    sx={{
                      background: "#fff",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
                <Box className="input-number-button">
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    sx={{
                      marginLeft: "1rem",
                      backgroundColor: "#15741a",
                      textTransform: "capitalize",
                      padding: "10px 20px",
                    }}
                  >
                    Share App Link
                  </Button>
                </Box>
              </Box>
              <br />
              <Typography sx={{ fontWeight: 600 }} variant="body1">
                Download the app from
              </Typography>
              <div className="get-app-logo">
                <a
                  href="https://apps.apple.com/in/app/salontym-salon-at-home/id6444617786"
                  target="_blank"
                >
                  <Image
                    className="download"
                    src={AppleStore}
                    width={500}
                    height={200}
                    alt="Apple Store Download Button"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN"
                  target="_blank"
                >
                  <Image
                    className="download"
                    src={AndriodStore}
                    width={500}
                    height={200}
                    alt="Android Store Download Button"
                  />
                </a>
              </div>
              <Typography variant="body2">
                Or you can also access our services at www.salontym.com from
                <br />
                your mobile phone or computer
              </Typography>
            </div>
            {/* <div className="hero__mockups">
              <div className="screen">
                <Image src={Iphone} width={1000} height={2000} alt="iphone" />
                <div className="screen__inner">
                  <div className="screen__header logo">SalonTym</div>
                  <div className="screen__middle bg-yellow">
                    <p className="question">Don&#39;t wait! Download App now</p>
                    <p className="subheader">
                      1000+ services available to uplift your mood:
                    </p>
                    <div className="bg-purple">
                      <ul className="items">
                        <li>✨ 8 Quick Boosts</li>
                        <li>📖 15 Skincare Secrets</li>
                        <li>🎶 25 Makeup Vibes</li>
                        <li>🎙️ 15 Beauty Insights</li>
                        <li>👩‍🎤 1000+ Experts</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="screen">
                <Image src={Iphone} width={1000} height={2000} alt="iphone" />
                <div className="screen__inner">
                  <Image
                    src={AppImage}
                    width={1000}
                    height={2000}
                    alt="SalonTym App"
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetApp;
